import React, { Component } from 'react';
import isPast from 'date-fns/is_past';
import format from 'date-fns/format';
import Timer from '~/components/Timer';
import './SportBanner.css';

class GameBanner extends Component {
  state = {
    desktopMode: window.innerWidth >= 750
  }
  
  componentDidMount = () => {
    window.addEventListener('resize', _ => {
      this.setState({ desktopMode: window.innerWidth >= 750 })
    }, false)
  }
  
  hideTimer = () => {
    this.setState(this.state);
    this.props.displayTabs();
  }

  render() {
    const env = this.props.env;
    const schedule = this.props.page[env.schedule][0];

    return (
      <div className='gamebanner-container' >
        <div className='banner' 
            style={{ backgroundImage: `url(${this.state.desktopMode ? 
            this.props.page.imageGist._32x9 : this.props.page.imageGist._16x9 })`}}>
          { isPast(this.props.faceoffTime) ? 
            env.scoreboard && <env.scoreboard data={this.props.data} />  :
            (
              this.props.selection ?  
              <Timer header={env.faceoff || 'Time until faceoff'} startTime={this.props.faceoffTime} hide={this.hideTimer} /> :
              env.scoreboard && <env.scoreboard data={this.props.data} />
            ) 
          }
        </div>
        <div className='bottom-section site-background-color'>
          <div className='section-wrapper'>
            {env.bannerInfo && <env.bannerInfo page={this.props.page} data={this.props.data} faceoffTime={this.props.faceoffTime}/>}
            <div className='wrapper'>
              <div className='venue'>
                <span>
                  {format(`${schedule.orgEventDate} ${schedule.orgEventTime}`, 'MM/DD - hh:mm A')} {schedule[env.timezone]}
                </span>
                <span>{schedule.venue}</span>
              </div>
              { isPast(this.props.faceoffTime) ? 
                <div /> : 
                this.props.page.ticketUrl && <button className='ticket-button' style={{ 'visibility': this.props.selection? 'visible' : 'hidden' }}>
                  <a href={this.props.page.ticketUrl} target="_blank">Buy Tickets</a>
                </button> 
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default GameBanner;